import css from 'styled-jsx/css';

const styles = css.global`.store-not-found .error-icon {
  margin: 0 auto;
  display: block;
}

.store-not-found .title {
  font-family: 'SantanderText';
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  margin: 0;
  color: #222;
  margin: 11px auto;
}

.store-not-found .description {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #222;
  margin: 0 0 40px;
}

.store-not-found .sn-button.white {
  margin-bottom: 16px;
}

.store-not-found {
  padding-bottom: 200px;
}

@media (min-width: 992px) {
  .store-not-found {
    max-width: 420px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .store-not-found > .ctn-home-24 {
    padding: 0;
  }

  .store-not-found .sn-button {
    max-width: 272px;
    margin-left: auto;
    margin-right: auto;
  }
}
`;

export default styles;